import { AxiosError } from "axios";

/**
 * Универсальный обработчик ошибок для API запросов и других операций
 * @param error Объект ошибки (ожидается AxiosError или стандартная Error)
 * @param context Дополнительный контекст для логирования (название модуля/компонента)
 */
export function catchError(error: unknown, context?: string): void {
  const prefix = context ? `[${context}]` : "[Error Handler]";

  if (isAxiosError(error)) {
    // Обработка ошибок Axios
    if (error.response) {
      // Сервер ответил с ошибкой (4xx/5xx)
      console.error(`${prefix} API Error Response:`, {
        status: error.response.status,
        data: error.response.data,
        headers: error.response.headers,
        url: error.config?.url,
      });
    } else if (error.request) {
      // Запрос был сделан, но ответ не получен
      console.error(`${prefix} Network Error:`, {
        message: error.message,
        request: error.request,
      });
    } else {
      // Ошибка в настройке запроса
      console.error(`${prefix} Request Setup Error:`, error.message);
    }
  } else if (error instanceof Error) {
    // Стандартные JavaScript ошибки
    console.error(`${prefix} General Error:`, {
      name: error.name,
      message: error.message,
      stack: error.stack,
    });
  } else {
    // Неизвестный тип ошибки (не Error и не AxiosError)
    console.error(`${prefix} Unknown Error Type:`, error);
  }
}

// Type guard для проверки типа AxiosError
function isAxiosError(error: unknown): error is AxiosError {
  return typeof error === "object" && error !== null && "isAxiosError" in error;
}
